// Feature flags driven by .env (REACT_APP_FEATURE_*).
// Values are strings in CRA env — treat anything other than "true" as false.
// Default OFF so a missing env var hides an unfinished feature rather than exposing it.

const flag = (value: string | undefined): boolean =>
  (value ?? '').trim().toLowerCase() === 'true';

export const FEATURES = {
  newDesign: flag(process.env.REACT_APP_FEATURE_NEW_DESIGN),
  newAlerts: flag(process.env.REACT_APP_FEATURE_NEW_ALERTS),
  users: flag(process.env.REACT_APP_FEATURE_USERS),
  helpSupport: flag(process.env.REACT_APP_FEATURE_HELP_SUPPORT),
  demoDevice: flag(process.env.REACT_APP_FEATURE_DEMO_DEVICE), // master switch for demo device visibility
} as const;

export type FeatureKey = keyof typeof FEATURES;
